
export const featurePaths = {
    JobList: "/joblist",
    CreateJob: "/joblist/createjob",
    EditJob: "/joblist/editjob",
    AddmultipleService: "/joblist/addmultipleservice",
    UpdatePreAlert:"/joblist/editjob/updateprealertdata",
    ViewPreAlert:"/joblist/editjob/viewprealertdata",
    ReturnSenderInstruction:"/joblist/editjob/returnsenderinstruction",
    RSIPreview:"/joblist/editjob/rsi-preview"
    
} as const;

export const apiPaths = {} as const;
